import BaseCom from "../../components/BaseCom";
import Card from "../../components/Card";
import Icon from "../../components/Icon";
import L from "../../components/Lang";
import DataView from "../../components/Solusek/DataView";
import Tick from "../../components/Tick";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import Globals from "../../shared/Globals";

class HealthMonitor extends BaseCom {

    tick =  () => {
        this.rehash();
    }


    render() {
        return (
            <div className="container-fluid">
                <Tick interval={15000} onTick={this.tick} />
                <h1><L>Health Monitor</L></h1>
                <DataView api={'/api/health/list'} hash={this.state.hash}
                    conditionals={[
                        {
                            condition: () => true,
                            contentFunc: row => row.isHealthy ? <span className="text-success"><Icon icon="faCircle" /> OK</span>
                                                                            : <span className="text-danger"><Icon icon="faSquare" /> {row.statusCode}</span>
                        },
                        {
                            condition: () => true,
                            contentFunc: row => <i className="text-muted">{Globals.toMDYHMAMPMLocalDateString(row.lastCheckDT)}</i>
                        }
                    ]}
                />
            </div>
        );
    }
}

export default withParamsAndNavigate(HealthMonitor);